<template>
  <div class="flex items-baseline sm:flex-col sm:items-start">
    <label
      v-if="label"
      :class="labelClass"
      class="flex-shrink-0 sm:mb-1 text-gray-500"
    >
      {{ label }}
    </label>
    <section
      v-if="$slots.label"
      class="flex-shrink-0 sm:mb-1 text-gray-500"
    >
      <slot name="label" />
    </section>
    <div :class="[inputWrapperClass]" class="flex flex-col">
      <div class="relative w-full">
        <input
          :class="[
            { 'pr-8': passwordReveal || showError || showSuccess },
            colorType,
            dense ? 'px-2 py-0' : 'px-3 py-2 sm:py-3',
            inputClass,
            variant,
          ]"
          :maxlength="maxLength"
          :type="currentType"
          :value="value"
          class="w-full w-input"
          ref="input"
          v-bind="$attrs"
          v-on="inputListeners"
        />
        <i
          v-if="passwordReveal"
          :class="{ 'icon-eye-open': !show, 'icon-eye-close': show }"
          class="text-xl w-input__icon"
          @click="show = !show"
        />
        <i
          v-else-if="showError"
          class="icon-alert-circle w-input__icon"
        />
        <i
          v-else-if="showSuccess"
          class="icon-success-circle w-input__icon"
        />
      </div>
      <section
        v-if="message || showCount"
        :class="{ 'justify-end': !message && showCount }"
        class="flex"
      >
        <span
          v-if="message"
          :class="{ 'text-red-500': showError }"
          class="mt-1 text-gray-500 text-sm"
        >
          {{ message }}
        </span>
        <span v-if="showCount && textCount" class="flex-shrink-0 ml-2 text-gray-300 text-xs">
          {{ textCount }}
          <span v-if="maxLength"> / {{ maxLength }}</span>
        </span>
      </section>
    </div>
  </div>
</template>

<script>
import WInput from './WInput';

export default WInput;
</script>

<style lang="scss" scoped>
@import 'WInput';
</style>
